import { Store, useStore } from 'vuex';
import API from '../../api';

export interface CompanyStaffStoreState {
  isLoading: boolean;
  isError: boolean;
  data: any;
  meta: any;
  error?: any;
}

export const CompanyStaffStoreImpl = {
  namespaced: true,

  state: (): CompanyStaffStoreState => ({
    isLoading: false,
    isError: false,
    data: null,
    meta: {}
  }),

  actions: {
    async updateState({ state }: { state: CompanyStaffStoreState }, args: { doUpdate: (state: CompanyStaffStoreState) => Promise<any> }) {
      return await args.doUpdate(state);
    }
  }
};

export class CompanyStaffStore {
  private store: Store<any>;

  public constructor(store: Store<any> | undefined = null) {
    this.store = store ? store : useStore();
  }

  public get state(): CompanyStaffStoreState {
    return this.store.state.companyStaff;
  }

  public dispatch<T>(doUpdate: (state: CompanyStaffStoreState) => Promise<T>): Promise<T> {
    return this.store.dispatch('companyStaff/updateState', { doUpdate });
  }

  public async init(params: any) {
    this.dispatch(async (state) => {
      state.isLoading = true;
      try {
        const res = await API.get(`admin/companies/${params.company}/users`, params);
        state.isLoading = false;
        state.data = res.data.data;
        state.meta = res.data.meta;
        state.isError = false;
        state.error = null;
      } catch (error) {
        state.error = error;
        state.isError = true;
        state.isLoading = false;
      }
    });
  }
}
